<div style="margin-left: 5%; margin-right: 5%; 
padding-right: 20px; margin-bottom: 30px; margin-top: 30px;">
<div style="padding: 5px; text-align: center; margin-bottom: 20px;
    border-radius: 25px; background-color: #4b8cc5;">
    <h2 mat-dialog-title style="color: white; margin-bottom: 0px;">Administrar las localidades</h2>
</div>
<button mat-raised-button class="btn-agregar" (click)="modificar('00000000-0000-0000-0000-000000000000')"
    style="margin-top: 1vh; width: auto; padding-left: 10px; padding-right: 10px;">
    Agregar localidad
</button>
</div>
<div style="margin-left: 5%; margin-right: 5%; padding: 10px;
  text-align: center;" [hidden]="escondeFraseNoHay">
    <h4 style="color: #a31611;"><b>Todavía no se agregó ninguna localidad</b></h4>
</div>
<div style="margin-left: 5%; margin-right: 5%; padding-left: 20px; padding-right: 20px;" 
    [hidden]="!escondeFraseNoHay">
    <div fxLayout fxLayoutAlign="center center">
        <mat-form-field fxFlex="40%">
          <input matInput type="text" (keyup)="buscar($any($event.target).value)" placeholder="Búsqueda"
            autocomplete="off"> 
        </mat-form-field>
    </div>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width: 100%;">
        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef style="width:10%;"> Acciones </th>
            <td mat-cell *matCellDef="let element">
                <i class="fas fa-pencil-alt" style="width: 10px; margin-right:5%;
                    font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                    margin-top: 0px; margin-right: 3vw;"
                    (click)="modificar(element.idLocalidad)"
                ></i>
            </td>
        </ng-container>
        <ng-container matColumnDef="habilitado">
            <th mat-header-cell *matHeaderCellDef style="width:10%; text-align:center;" mat-sort-header> Habilitado </th>
            <td mat-cell *matCellDef="let element" style="text-align:center;"> 
                <mat-checkbox [disabled]="true" [checked]="element.habilitado=='1'">
                </mat-checkbox>
            </td>
        </ng-container>
        <ng-container matColumnDef="nombre" style="width:10%;">
            <th mat-header-cell *matHeaderCellDef> Nombre</th>
            <td mat-cell *matCellDef="let element">
            {{element.nombre}}
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>">
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator #paginador [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>
<div style="text-align: center; margin-top: 20px;">
    <button mat-raised-button class="btn-agregar" (click)="volver()" style="margin-top: 1vh; 
        margin-bottom: 20px; width: 20%;">
        Volver
    </button>
</div>
